import { graphql } from "gql.tada";

export const CALCULATION_DETAIL_FRAGMENT = graphql(`
  fragment CalculationDetail on Calculation {
    id
    status
    name
    kamName
    line
    startDate
    endDate
    updatedAt
    version
    incompleteReason
    opDataSnapshot {
      sourceOpDataId
      sourceVersion
      fields {
        field
        coachTypes {
          coachType
          months {
            month
            value
          }
        }
      }
    }
    categories {
      subCategoryDefinitionId
      subCategoryName
      dimensionTypeId
      dimensionTypeName
      dimensionValues
      formulas {
        dimensionValue
        formula {
          expression
          extractedVariableIds
          sourceTemplateId
        }
      }
      referencedVariableSnapshots {
        variableId
        code
        displayName
        defaultDistributionType
        unit
      }
      variableInputs {
        variableId
        distributionType
        valuesByDimension {
          dimensionValue
          distributionType
          singleValue
          monthValues {
            year
            monthNumber
            value
          }
        }
      }
      result {
        monthlyAggregates {
          year
          monthNumber
          cell {
            value
            status
          }
        }
        bucketResults {
          dimensionValue
          monthlyAggregates {
            year
            monthNumber
            cell {
              value
              status
            }
          }
          total {
            value
            status
          }
        }
        total {
          value
          status
        }
      }
    }
  }
`);

export const GET_CALCULATION_DETAIL = graphql(
  `
    query GetCalculationDetail($id: ID!) {
      calculation(id: $id) {
        ...CalculationDetail
      }
    }
  `,
  [CALCULATION_DETAIL_FRAGMENT],
);

export const GET_CATEGORY_DEFINITIONS_FOR_DETAIL = graphql(`
  query GetCategoryDefinitionsForDetail {
    calculationCategoryDefinitions {
      id
      name
      subCategories {
        id
        name
      }
    }
  }
`);

export const GET_DIMENSION_TYPES = graphql(`
  query GetDimensionTypes {
    dimensionTypes {
      id
      name
      values
    }
  }
`);

export const FORMULA_TEMPLATES = graphql(`
  query FormulaTemplates($subCategoryId: ID!) {
    formulaTemplates(subCategoryId: $subCategoryId) {
      id
      name
      expression
      requiredVariableIds
    }
  }
`);

export const VARIABLE_DEFINITIONS = graphql(`
  query VariableDefinitions {
    variableDefinitions {
      code
      displayName
    }
  }
`);

export const OP_DATA_CATALOG = graphql(`
  query OpDataCatalog {
    opDataCatalog {
      code
      opDataField
      coachTypeAggregate
    }
  }
`);
